import { useEffect, useState } from 'react';
import { OnSelectChange } from '@ui/src';
import { CRSAndFatcaFormValues } from '../../../../hoc/new-application/types';

const useCRSAndFatca = ({
  crsAndFatcaValues,
  setCrsAndFatcaValues,
  crsAndFatca,
}: {
  crsAndFatcaValues?: CRSAndFatcaFormValues[];
  setCrsAndFatcaValues: (data: CRSAndFatcaFormValues[]) => void;
  crsAndFatca?: CRSAndFatcaFormValues;
}) => {
  const [formValues, setFormValues] = useState<CRSAndFatcaFormValues>();
  const [expanded, setExpanded] = useState(true);
  const [haveTin, setHaveTin] = useState(false);

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement> | OnSelectChange,
  ) => {
    const nextFormValues = { ...formValues };

    const nextValues = crsAndFatcaValues?.map((item) => {
      const result = { ...item };

      if (nextFormValues.id === item.id) {
        if (e.target.name === `residenceCountryId-${item.id}`) {
          nextFormValues.residenceCountryId = e.target.value as string;
          result.residenceCountryId = e.target.value as string;
        } else if (e.target.name === `taxIdentificationNumber-${item.id}`) {
          nextFormValues.taxIdentificationNumber = e.target.value as string;
          result.taxIdentificationNumber = e.target.value as string;
        } else if (e.target.name === `noTinReason-${item.id}`) {
          nextFormValues.noTinReason = e.target.value as string;
          result.noTinReason = e.target.value as string;
        }
      }

      return result;
    });

    setFormValues(nextFormValues as CRSAndFatcaFormValues);
    setCrsAndFatcaValues(nextValues as CRSAndFatcaFormValues[]);
  };

  const onChangeHaveTin = (checked: boolean) => {
    setHaveTin(checked);

    const nextFormValues = { ...formValues };

    const nextValues = crsAndFatcaValues?.map((item) => {
      const result = { ...item };

      if (nextFormValues.id === item.id) {
        if (checked) {
          nextFormValues.noTinReason = '';
          result.noTinReason = '';
        } else {
          nextFormValues.taxIdentificationNumber = '';
          result.taxIdentificationNumber = '';
        }
      }

      return result;
    });

    setFormValues(nextFormValues as CRSAndFatcaFormValues);
    setCrsAndFatcaValues(nextValues as CRSAndFatcaFormValues[]);
  };

  useEffect(() => {
    if (crsAndFatca) {
      setFormValues(crsAndFatca);
    }
  }, [crsAndFatca]);

  useEffect(() => {
    if (formValues?.taxIdentificationNumber) {
      setHaveTin(true);
    }
  }, [formValues]);

  return {
    expanded,
    setExpanded,
    onChangeHaveTin,
    onChange,
    haveTin,
    formValues,
  };
};

export default useCRSAndFatca;
